// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__undEP","title":"FrontImage_title__2nssf"};